<dialog
  #dialog
  class="general-modal"
  aria-labelledby="modal-header"
  aria-describedby="modal-description"
  aria-modal="true"
  role="dialog"
  id="help_popup"
>
  <div class="general-modal-box">
    <div
      class="general-modal-header info-modal__header flex items-center justify-between"
    >
      <span
        id="modal-header"
        *ngIf="content.title"
        class="text-label-md-medium text-inverse"
      >
        {{ content.title }}
      </span>
      <button
        (click)="closeDialog()"
        class="general-modal-close-button"
        aria-label="Close modal"
      ></button>
    </div>
    <div class="general-modal-content">
      <div class="flex flex-col gap-12 info-modal__body">
        <p
          *ngIf="content.description"
          id="modal-description"
          class="text-body-sm text-body-copy info-modal__body__desc"
          [innerHTML]="content.description"
        ></p>
      </div>
    </div>
  </div>
  <form method="dialog" class="general-modal-backdrop">
    <button aria-label="Close modal" (click)="closeDialog()">Close</button>
  </form>
</dialog>
